import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './lang/en.js'
import de from './lang/de.js'

Vue.use(VueI18n)

const locale = 'de'

const messages = {
    de,
    en
}

const i18n = new VueI18n({
    locale,
    messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/assets/i18n/lang.js